import {API_URL} from "../common/config";

const axios = require('axios');
const qs = require('qs');

const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    transformRequest: [function (data) {
        data = qs.stringify(data);
        return data;
    }],
});

instance.interceptors.request.use(config => {
    if (localStorage.sinochemtoken) {
        config.headers.SinochemToken = encodeURI(localStorage.sinochemtoken);
    }
    return config;
}, err => {
    return Promise.reject(err);
});

export default instance;